import { defineComponent, computed } from "vue";
import VariantSelector from "./component-library270.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "single-item-configurator",
  props: {
    bundleItem: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["select-variant"],
  setup(__props) {
    const props = __props;
    const filteredVariants = computed(() => {
      var _a;
      if (!((_a = props.bundleItem) == null ? void 0 : _a.variants))
        return [];
      const filterd = [];
      Object.keys(props.bundleItem.variants).forEach((key) => {
        const entry = props.bundleItem.variants[key];
        if (!entry)
          return;
        filterd.push(entry);
      });
      return filterd;
    });
    return { __sfc: true, props, filteredVariants, VariantSelector };
  }
});
export {
  _sfc_main as default
};
